import request from '@/utils/ai-train-request'

// AI训战 - 角色风格库（ai_role_style：role_type 1挑剔/2友好/3应付）
// 任务书 §1.3 没有给它单独的页面，本工程把它做成 scene 页里的一个子面板（不是独立菜单/路由），
// 详见 src/views/aiTrain/scene/RoleStylePanel.vue
const apiPath = '/admin/role-style'

const aiTrainRoleStyleApi = {
  fetchList(query) {
    return request({ url: apiPath, method: 'get', params: query })
  },
  create(data) {
    return request({ url: apiPath, method: 'post', data })
  },
  update(data) {
    return request({ url: apiPath, method: 'put', data })
  },
  deleteById(id) {
    return request({ url: `${apiPath}/${id}`, method: 'delete' })
  }
}

export default aiTrainRoleStyleApi
